import { styled } from '@nx-kit/styling';
import { RichText } from 'components/atoms/RichText';
import { Loading } from 'components/atoms/Loading';
import Icon from 'components/atoms/Icon/Icon';

export const IconCloseStyled = styled(Icon)`
  color: ${({ theme }) => theme.global.color.primary};
`;

export const ModalStyled = styled.div`
  background-color: ${(props) => props.theme.global.color.white};
  min-height: 300px;
  width: 300px;
  top: 100px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  position: absolute;
  display: flex;
  flex-direction: column;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  padding: 20px;
  z-index: ${({ theme }) => theme.global.zIndex.two};
`;

export const ModalCloseStyled = styled.div`
  cursor: pointer;
  text-align: right;
  height: 20px;
  width: 20px;
`;

export const HeaderHeadlinesStyled = styled.div`
  flex: 1;
`;

export const ModalHeaderStyled = styled.div`
  display: flex;
  flex-direction: row;
`;

export const HeadlineStyled = styled.div`
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
`;

export const ImageWrapperStyled = styled.div`
  width: 100%;
  height: auto;
  margin-bottom: 15px;
`;

export const RichTextStyled = styled(RichText)`
  font-size: 13px;
  line-height: 20px;
`;

export const LoadingStyled = styled(Loading)`
  align-self: center;
  margin-top: auto;
  margin-bottom: auto;
`;
